 <ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
  <ion-toolbar mode="md">

    <ion-title color="secondary" class="ion-text-center header-title">{{ 'LOGIN.TITLE' | translate }}</ion-title>

    <ion-buttons slot="start">
      <ion-back-button color="secondary" defaultHref="/" text=""></ion-back-button>
    </ion-buttons>

    <app-top-right color="secondary" slot="end"></app-top-right>

  </ion-toolbar>
  </ion-grid>
</ion-header>

<ion-content>

  <ion-grid>
    <ion-row>
      <ion-col offset-lg="4" offset-md="3" offset-sm="2" size-sm="8" size-md="6" size-lg="4">

        <app-social-login></app-social-login>


        <div class="ion-padding ion-text-center facebook-not" mode="md">
          <div class="facebook-not__inner">{{ 'LOGIN.OR' | translate }}</div>
        </div>

        <app-email-login-form></app-email-login-form>

         
      </ion-col>

    </ion-row>
  </ion-grid>

 
</ion-content>